import { useEffect, useState } from "react";
import { api } from "@/AuthContext";

// Cache compartido (encabezado + panel) para no repetir la carga de la misma estructura
const TTL_MS = 60_000;
const cache = new Map(); // sid -> { at, promise, data }

function fetchDetail(sid) {
  const hit = cache.get(sid);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const entry = { at: Date.now() };
  entry.promise = api.get(`/organizations/${sid}`).then(r => { entry.data = r.data; return r.data; })
    .catch(e => { cache.delete(sid); throw e; });
  cache.set(sid, entry);
  return entry.promise;
}

export function prefetchStructures(ids) { (ids || []).forEach(id => { fetchDetail(id).catch(() => {}); }); }

// Detalle (niveles + nodos) de una estructura organizacional
export function useStructureDetail(sid) {
  const [detail, setDetail] = useState(() => (sid && cache.get(sid)?.data) || null);
  useEffect(() => {
    if (!sid) { setDetail(null); return; }
    let alive = true;
    const cached = cache.get(sid)?.data;
    if (cached) setDetail(cached); else setDetail(null);
    fetchDetail(sid).then(d => { if (alive) setDetail(d); }).catch(() => { if (alive) setDetail(null); });
    return () => { alive = false; };
  }, [sid]);
  return detail;
}

// ¿El usuario puede navegar estructuras?
export function canUseStructures(user, structures) {
  if (!structures || structures.length === 0) return false;
  return !(user?.access_mode === "companies" && user?.role !== "super_admin");
}
